import { Quotation } from 'src/types';

export const quotationProductTemplateFormater = (itemsArg: Quotation[]) => {
  const products = itemsArg?.filter((x) => {
    if (x?.product?.product_name) {
      return {
        custom: x.product.custom,
        quantity: x.quantity,
        product: {
          id: x.product.product_id,
          product_id: x.product.product_id,
          retail_price: x.product.retail_price,
          category_id: x.product.category_id,
          category_name: x.product.category_name
        }
      };
    }
  });

  return products;
};
